import React from 'react'
import { useIdentity } from 'pages/Identity/Login'
import { AuthenticatedFilters } from './AuthenticatedFilters'
import { PublicFilters } from './PublicFilters'

export const Filters = ({
  filterType,
  filterValues,
  listType,
  loading,
  applyFilters,
  disabled,
  resultCount,
  favoritesOnly,
  onToggleFavorites,
  isAIMode,
  onAiChipDelete,
}) => {
  const { signedIn } = useIdentity()
  return signedIn ? (
    <AuthenticatedFilters
      filterType={filterType}
      filterValues={filterValues}
      listType={listType}
      loading={loading}
      applyFilters={applyFilters}
      disabled={disabled}
      resultCount={resultCount}
      favoritesOnly={favoritesOnly}
      onToggleFavorites={onToggleFavorites}
      isAIMode={isAIMode}
      onAiChipDelete={onAiChipDelete}
    />
  ) : (
    <PublicFilters
      filterType={filterType}
      filterValues={filterValues}
      listType={listType}
      applyFilters={applyFilters}
      disabled={disabled}
    />
  )
}
